var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFavoritesOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1086 1.75309C10.4793 1.02408 11.5207 1.02407 11.8914 1.75308L14.421 6.72806C14.45 6.7851 14.5046 6.82482 14.5678 6.83491L20.0707 7.71332C20.8759 7.84185 21.1971 8.82819 20.6219 9.40618L16.6816 13.3661C16.6366 13.4113 16.6159 13.4752 16.6257 13.5382L17.4938 19.0621C17.6206 19.8691 16.7788 20.4794 16.0512 20.1079L11.0909 17.5753C11.0338 17.5461 10.9662 17.5461 10.9091 17.5753L5.94879 20.1079C5.22124 20.4794 4.37936 19.8691 4.50618 19.0621L5.37425 13.5382C5.38415 13.4752 5.36342 13.4113 5.31845 13.3661L1.37806 9.40618C0.802928 8.82819 1.1241 7.84185 1.92929 7.71332L7.43224 6.83491C7.49544 6.82482 7.54999 6.78511 7.579 6.72806L10.1086 1.75309Z",
    fill: "#6E8CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFavoritesOn);
export default __webpack_public_path__ + "static/media/ic_favorites_on.8582b522a3d874b4cadd4a792a09a88e.svg";
export { ForwardRef as ReactComponent };